export default "__VITE_ASSET__CmQIUzQO__"